// extracted by mini-css-extract-plugin
module.exports = {"list":"style__list__febxr","item":"style__item__qFw3q"};